import script from "./menuIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./menuIndex.vue?vue&type=script&setup=true&lang=js"

import "./menuIndex.vue?vue&type=style&index=0&id=53d92532&lang=scss"

const __exports__ = script;

export default __exports__